export default __webpack_public_path__ + "static/media/debtor.d52a62a4.svg";